export const EXAM_TYPES = ['KCET', 'NEET', 'JEE'];

export const INDIAN_STATES = [
  'Andaman and Nicobar Islands', 'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chandigarh',
  'Chhattisgarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Goa', 'Gujarat', 'Haryana',
  'Himachal Pradesh', 'Jammu and Kashmir', 'Jharkhand', 'Karnataka', 'Kerala', 'Ladakh', 'Lakshadweep',
  'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Puducherry',
  'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
  'West Bengal',
];

// WhatsApp support line (Indian number, +91)
export const SUPPORT_WHATSAPP = '8088203437';

// One colour per subject, so cards can be scanned at a glance. Matched on the name's start, so
// "Maths" / "Mathematics" or "Physics" / "physics" all work.
const SUBJECT_COLORS = [
  ['phys', { bg: '#eff6ff', fg: '#1d4ed8', border: '#bfdbfe' }],
  ['chem', { bg: '#faf5ff', fg: '#7e22ce', border: '#e9d5ff' }],
  ['bio', { bg: '#ecfdf5', fg: '#047857', border: '#a7f3d0' }],
  ['math', { bg: '#fff7ed', fg: '#c2410c', border: '#fed7aa' }],
];
export const subjectColor = (name) =>
  SUBJECT_COLORS.find(([key]) => String(name).toLowerCase().startsWith(key))?.[1]
  ?? { bg: '#f8fafc', fg: '#475569', border: '#e2e8f0' };
